import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import { HStack } from '~/components/elements/HStack'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { NineSegmentSelector } from '~/components/features/NineSegmentSelector'
import { reversedNineSegments } from '~/utils'

import { type InputValues } from '../utils'

const getName = (nineSegmentIndex: number) =>
  `segment_definitions.${nineSegmentIndex}.condition_groups` as const

export type ConditionGroupCopierProps = {
  nineSegmentIndex: number
}

export const ConditionGroupCopier = ({
  nineSegmentIndex,
}: ConditionGroupCopierProps) => {
  const { t } = useTranslation()
  const { getValues, setValue } = useFormContext<InputValues>()

  const [nineSegment, setNineSegment] = React.useState(
    reversedNineSegments[nineSegmentIndex],
  )

  const handleCopyButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    const copyFromIndex = reversedNineSegments.findIndex(
      R.isDeepEqual(nineSegment),
    )
    const value = getValues(getName(copyFromIndex))
    setValue(getName(nineSegmentIndex), value)
  }, [getValues, nineSegment, nineSegmentIndex, setValue])

  return (
    <HStack spacing={4}>
      <NineSegmentSelector
        value={nineSegment}
        width={160}
        onChange={setNineSegment}
      />

      <StyledButton onClick={handleCopyButtonClick}>
        {t('copy_setting_conditions')}
      </StyledButton>
    </HStack>
  )
}
